"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePositionForHeaderEvents = void 0;
const Helper_1 = require("./Helper");
const KalendHelper_1 = require("./KalendHelper");
const commonHelper_1 = require("./commonHelper");
const monthView_1 = require("../views/monthView");
const calculatePositionForHeaderEvents = (events, width, calendarDays, config, selectedView) => {
    if (!events) {
        return [[]];
    }
    const breakPointDate = (0, Helper_1.formatToDateKey)(calendarDays[calendarDays.length - 1], config.timezone);
    const preparedEvents = (0, monthView_1.prepareMultiDayEvents)(events, config, breakPointDate, selectedView);
    const rowResult = (0, commonHelper_1.getRowLayout)(preparedEvents, width / (0, KalendHelper_1.getDaysNum)(selectedView), calendarDays, config.timezone, 150, true);
    return rowResult;
};
exports.calculatePositionForHeaderEvents = calculatePositionForHeaderEvents;
